import tinycolor from "tinycolor2";

const primary = "#03b1fc";
const secondary = "#5aa469";
const warning = "#fc5203";
const success = "#3CD4A0";
const info = "#fcfc03";

const lightenRate = 7.5;
const darkenRate = 15;

export default {
  direction: "ltr",
  palette: {
    primary: {
      main: primary,
      light: tinycolor(primary).lighten(lightenRate).toHexString(),
      dark: tinycolor(primary).darken(darkenRate).toHexString(),
    },
    secondary: {
      main: secondary,
      light: tinycolor(secondary).lighten(lightenRate).toHexString(),
      dark: tinycolor(secondary).darken(darkenRate).toHexString(),
      contrastText: "#FFFFFF",
    },
    warning: {
      main: warning,
      light: tinycolor(warning).lighten(lightenRate).toHexString(),
      dark: tinycolor(warning).darken(darkenRate).toHexString(),
    },
    success: {
      main: success,
      light: tinycolor(success).lighten(lightenRate).toHexString(),
      dark: tinycolor(success).darken(darkenRate).toHexString(),
    },
    info: {
      main: info,
      light: tinycolor(info).lighten(lightenRate).toHexString(),
      dark: tinycolor(info).darken(darkenRate).toHexString(),
    },
    text: {
      primary: "#000000",
      secondary: "#4A4A4A",
      hint: "#6E6E6E",
    },
    background: {
      default: "#fff",
      light: "#F3F5FF",
      header: "rgba(202,202,202,0.8)",
      sideBar: "#0034a3",
      lightGreen: "#b3ffd9",
      lightPink: "#ffb3c1",
    },
  },
  customShadows: {
    widget:
      "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
    widgetDark:
      "0px 3px 18px 0px #4558A3B3, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
    widgetWide:
      "0px 12px 33px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
  },
  overrides: {
    // MuiCssBaseline: {
    //   "@global": {
    //     body: {
    //       // background: `linear-gradient(to right, #c0c0aa, #1cefff)`,
    //       background: `url(${persianGulf})`,
    //       backgroundSize: "cover",
    //     },
    //   },
    // },
    MuiBackdrop: {
      root: {
        backgroundColor: "#4A4A4A1A",
      },
    },
    MuiMenu: {
      paper: {
        boxShadow:
          "0px 3px 11px 0px #E8EAFC, 0 3px 3px -2px #B2B2B21A, 0 1px 8px 0 #9A9A9A1A",
      },
    },
    MuiSelect: {
      icon: {
        color: "#B9B9B9",
      },
    },
    MuiListItem: {
      root: {
        "&$selected": {
          backgroundColor: "#F3F5FF !important",
          "&:focus": {
            backgroundColor: "#F3F5FF",
          },
        },
      },
      button: {
        "&:hover, &:focus": {
          backgroundColor: "#F3F5FF",
        },
      },
    },
    MuiTouchRipple: {
      child: {
        backgroundColor: "white",
      },
    },
    MuiTableRow: {
      root: {
        height: 56,
      },
    },
    MuiTableCell: {
      root: {
        borderBottom: "1px solid rgba(224, 224, 224, .5)",
        paddingRight: 24,
      },
      head: {
        fontSize: "0.95rem",
        textAlign: "right",
      },
      body: {
        fontSize: "0.95rem",
        textAlign: "right",
      },
    },
    PrivateSwitchBase: {
      root: {
        marginRight: 10,
      },
    },
    MuiTypography: {
      root: {
        // fontfamily:"IRANSansWeb(FaNum) !important"
      },
    },
    MuiListItemText: {
      root: {
        textAlign: "right",
      },
    },
    MUIDataTable: {
      responsiveStacked: {
        overflow: "hidden !important",
      },
    },
  },
};
